import React, { Component } from 'react';
import {
	Button,
	Card,
	CardBody,
	CardGroup,
	ListGroup,
	ListGroupItem,
	Col,
	Container,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Row,
	Alert
} from 'reactstrap';

//import { COMPANY_ACCESS } from '../../constants/general';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { login, setValues } from '../../store/actions/userActions';
import { Preloader } from '../Plugins/';
//import ReCAPTCHA from "react-google-recaptcha";
import HCaptcha from '@hcaptcha/react-hcaptcha';
import Notification from '../../handlers/Notification';
/*import FacebookLogin from 'react-facebook-login';
const responseFacebook = (response) => {
  console.log(response);
}*/
const data = {
	'email': '',
	'password': '',
};

//const recaptchaRef = React.createRef();

class Login extends Component {

	constructor(props) {
		super(props);

		this.state = {
			activeStep: 1,
			validCapta:false
			//isLoading: false
		}
		//captchaRef.current.execute();
	}
	
	componentWillMount () {
		if(localStorage.getItem('user')){
			this.props.history.push('/')
		}
	}

	componentDidUpdate(prevProps){
		/* if(prevProps.loginError !== this.props.loginError && this.props.loginError === true){
			this.setState({ isLoading: false })
		} */

		if (prevProps.branches.length !== this.props.branches.length) {
			this.setState({
				activeStep: 2
			})
		}

		/* // esto era para el owner... para el group servira?
			if (prevProps.userHigherAccess !== this.props.userHigherAccess && this.props.userHigherAccess === COMPANY_ACCESS) {
			this.setState({
				activeStep: 2
			})
		} */
	}
	
	setUserAcess = (id, type) => {
		let unit;
		if (type === "branch"){
			unit = this.props.branches.find(b => b.access_id === id); // es la branch seleccionada x el usr (si puede ver varias)

			localStorage.setItem('activeBranch', JSON.stringify(unit.related_access));
			window.location.href = '/orders-managment'
		}

		else{
			unit = this.props.branchGroups.find(b => b.access_id === id); // es el branch group seleccionado x el usr (si puede ver varias)

			localStorage.setItem('activeBranchGroup', JSON.stringify(unit.related_access));
		}
	}

	sendUserData = () => {
		/* this.setState({
			isLoading: true
		}) */
		if(this.state.validCapta === true){
			this.props.login(data)
		}else{
			console.log("Eres un robot?");
			Notification.show({ type: "warning", title:"Eres un robot?", msg: 'beeb... boob, beeb' });
		}
	}

	/*ReCAPTCHAaction(){
		if(recaptchaRef.current.getValue()){
			this.setState({validCapta:true})
		}
	}*/

	handleVerificationSuccess(token, ekey){
		if(token){
			this.setState({validCapta:true})
		}
	}
	render = () => {
		console.log("this.props.company_logo",this.props.company_logo)
		let logo = this.props.company_logo ? this.props.company_logo:''
		const version = process.env.REACT_APP_VERSION || '1.0.0'
		const build = process.env.REACT_APP_BUILD

    	if(process.env.REACT_APP_ENV === "DEV" || process.env.REACT_APP_ENV === "LOCAL"){
    		logo = this.props.company_logo ? this.props.company_logo:''
    	}
    	else if(process.env.REACT_APP_ENV === "STAGING"){
    		logo = this.props.company_logo ? this.props.company_logo:''
    	}
		let card, listBranchGroups, listBranches;

		if (this.props.branchGroups && this.props.branchGroups.length > 0)
			listBranchGroups = <ListGroup className="mt-2" style={{maxHeight:"270px",overflow:"auto"}}>
								<ListGroupItem tag="button" className="login-item-list-title" disabled><i className="icon-list"></i> {this.props.json_lang.login.select_branch_group}</ListGroupItem>
								{
									this.props.branchGroups.map( (b,key) => <ListGroupItem key={key} tag="button" onClick={e => this.setUserAcess(b.access_id, "branch_group")}>{b.related_access && b.related_access.name}</ListGroupItem>)
								}
							</ListGroup>
		if (this.props.branches && this.props.branches.length > 0)
			listBranches = <ListGroup className="mt-2" style={{maxHeight:"270px",overflow:"auto"}}>
							<ListGroupItem tag="button" className="login-item-list-title" disabled ><i className="fa fa-sitemap"></i> {this.props.json_lang.login.select_branch}</ListGroupItem>
							{
								this.props.branches.map( (b,key) => <ListGroupItem key={key} tag="button" onClick={e => this.setUserAcess(b.access_id, "branch")}>{b.related_access && b.related_access.name}</ListGroupItem>)
							}
						</ListGroup>

		if (this.state.activeStep !== 1 && this.props.adminWithoutAccess) {
			card = <Card className="p-4">
					<CardBody>
						<img  
							style={{display:'block',margin:'0 auto',maxWidth: '100%',height: '90px'}}
							ref={ `provider-img`}  
							src={  logo } 
							onError={ ()=>this.refs[`provider-img`].src= '/assets/img/logo-default-180x64.svg' }
							alt={  "" } />
						<h2 style={{textAlign: 'center'}}>
							{this.props.json_lang.login.login_title} {this.props.company_name?this.props.company_name:'' }
						</h2>
						<p>Su usuario no ha recibido privilegios para entrar a este panel administrativo, por favor comuníquese con algún usuario administrativo que le otorgue acceso.</p>
					</CardBody>
				</Card>
		}

		
		else if (this.state.activeStep === 1) {
			card = <Card className="p-3">
					<CardBody>
						<img  
							style={{display:'block',margin:'0 auto',maxWidth: '100%',height: '90px'}}
							ref={ `provider-img`}  
							src={  logo/*this.props.company_logo?this.props.company_logo:'/assets/img/logo-default-180x64.svg'*/ } 
							onError={ ()=>this.refs[`provider-img`].src= '/assets/img/logo-default-180x64.svg' }
							alt={  "" } />
						<h2 style={{textAlign: 'center'}}>
							{this.props.json_lang.login.login_title} {this.props.company_name?this.props.company_name:'' }
						</h2>
						<p className="text-muted">{this.props.json_lang.login.login_subtitle}</p>
						
						<InputGroup className="mb-3">
							<InputGroupAddon addonType="prepend">
								<InputGroupText>
									<i className="icon-user"></i>
								</InputGroupText>
							</InputGroupAddon>
							<Input type="text" name="email" placeholder={this.props.json_lang.common.email} 
							onKeyPress={({ key }) => key === "Enter" ? this.sendUserData() : null} 
							onChange={ (e) => data.email = e.target.value }/>
						</InputGroup>
						
						<InputGroup className="mb-3">
							<InputGroupAddon addonType="prepend">
								<InputGroupText>
									<i className="icon-lock"></i>
								</InputGroupText>
							</InputGroupAddon>
							<Input type="password" name="password" placeholder={this.props.json_lang.login.password_placeholder}
							onKeyPress={({ key }) => key === "Enter" ? this.sendUserData() : null}  onChange={ (e) => data.password = e.target.value }/>
						</InputGroup>

						{
							/*
							<ReCAPTCHA
													className="captcha"
													ref={recaptchaRef}
													sitekey={this.props.siteKey}
													onChange={()=>this.ReCAPTCHAaction()}
												/>
							*/
						}
						<div style={{display: "flex",justifyContent: "center",marginBottom: "1rem"}}>
							<HCaptcha
								sitekey={this.props.siteKey}
								onVerify={(token,ekey) => this.handleVerificationSuccess(token, ekey)}
							/>
						</div>
						<Button
							style={{height: '55px',fontWeight: 'bold'}}
							color={`primary btn-block ${!this.state.validCapta ? `disabled`:''}`}
							onClick={ () => this.sendUserData()}>
							{this.props.json_lang.login.login_button}
						</Button>
							
						<Link to="/password-reset" style={{textAlign:'center'}} className="mt-3 btn-block text-muted">{this.props.json_lang.login.forgot_password_link}</Link>
							

						{/*<FacebookLogin
							appId="1088597931155576"
							autoLoad={true}
							fields="name,email,picture"
							icon="fa-facebook"
							callback={responseFacebook} />
						*/}
					</CardBody>
				</Card>
		} 
		else if (this.state.activeStep === 2) {
			card = <Card className="p-4">
					<CardBody>

						<img
							style={{display:'block',margin:'0 auto',maxWidth: '100%',height: '90px'}}
							ref={ `provider-img`}  
							src={ logo/*this.props.company_logo?this.props.company_logo:'/assets/img/logo-default-180x64.svg'*/ } 
							onError={ ()=>this.refs[`provider-img`].src= '/assets/img/logo-default-180x64.svg' }
							alt={  "" }
						/>
						<h4>Hola {this.props.session.name}, deseas:</h4>
						<br />
						{listBranchGroups}
						{listBranches}
					</CardBody>
				</Card>
		}



		return (
			<div className="app flex-row align-items-center custom_bg" >
				{
					/* la fecha de exp de la compania es antes que hoy ==> ya se vencio */
					this.props.company && !this.props.company.enabled ?
						(<div style={{margin: 0,textAlign: 'center', position: 'absolute', top: 0, width: '100%'}}>
							<Alert color="warning mb-0">
								{this.props.json_lang.default_layout.notification_company_requires_payment}
							</Alert>
						</div>)
					: null
				}
				<Container>
					<Row className="justify-content-center">
						<Col md="5">
							<CardGroup>
								{ card }
							</CardGroup>
							<div className="p-3 text-center text-muted">
								v{version}{ build ? ` (${build})` : '' }{ process.env.REACT_APP_ENV === 'PRODUCTION' ? '' : ('-'+process.env.REACT_APP_ENV) }
							</div>
							
						</Col>
					</Row>
					
				</Container>
				<Preloader />
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		session: state.session,
		userHigherAccess: state.userHigherAccess,
		adminWithoutAccess: state.adminWithoutAccess,
		loginError: state.loginError,
		branches: state.branches,
		branchGroups: state.branchGroups,
		errors: state.errors,
		json_lang: state.json_lang,
		company: state.company,
		company_logo:state.company_styles_json.company_logo,
		company_name:state.company.name,
		//siteKey:'6Lc3MWUbAAAAAFprmTsOkIySY2rkKQDmIuREhbSQ'
		siteKey:'e211dd04-09e9-4ba7-a0fd-d0e77fd87a9e'
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		setValues: (target) => dispatch(setValues(target)),
		login: (user) => dispatch(login(user))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);




// WEBPACK FOOTER //
// ./src/views/Login/Login.js